import * as React from 'react';

export class Map extends React.Component<any, any> {
    componentDidMount() {
        const script = document.createElement("script");
        const container = document.getElementById('heading-map');
        script.src = "https://api-maps.yandex.ru/services/constructor/1.0/js/?sid=2Lu15pHutQ7T-n_ixYJq9Nw2YbzPpYFv&amp;width=100%&amp;height=400&amp;lang=ru_RU&amp;sourceType=constructor&amp;scroll=true";
        script.async = true;
        script.charset = 'UTF-8';
        container.appendChild(script);
    }
    
    render() {
        return (
            <section className="sony-map">
                <div id="heading-map" style={{width: "100%", height: '400px'}}></div>
            </section>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/Map.tsx
 **/